module.exports = __webpack_public_path__ + "img/Group 15@2x.png";